// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2P2seF7EsNRtVPgrUDdpUM
// Component: JHalXuGbmA
import * as React from "react";
import { Link } from "gatsby";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import AllTalks from "../../AllTalks"; // plasmic-import: 7OmhVDvpeS/component
import TalkPreview from "../../TalkPreview"; // plasmic-import: B9ZCf2MIsEY/component
import Copyright from "../../Copyright"; // plasmic-import: smhgwqfGPU/component
import "@plasmicapp/react-web/lib/plasmic.css";
import * as projectcss from "./plasmic_isaacpalka_com.module.css"; // plasmic-import: 2P2seF7EsNRtVPgrUDdpUM/projectcss
import * as sty from "./PlasmicTalks.module.css"; // plasmic-import: JHalXuGbmA/css
import talkNlpsummitWYpPosvnr from "./images/talkNlpsummit.png"; // plasmic-import: wYpPOSVNR/picture
import talkSealightsCJ3Kr0Ru from "./images/talkSealights.png"; // plasmic-import: cJ3-Kr0ru/picture
import talkWorldfestival1XYq3YTn9 from "./images/talkWorldfestival.png"; // plasmic-import: 1xYq3yTN9/picture

createPlasmicElementProxy;

export const PlasmicTalks__VariantProps = new Array();

export const PlasmicTalks__ArgProps = new Array();

const $$ = {};

export function Head() {
  return (
    <>
      <meta name="twitter:card" content="summary" />
      <title key="title">{PlasmicTalks.pageMetadata.title}</title>
      <meta
        key="og:title"
        property="og:title"
        content={PlasmicTalks.pageMetadata.title}
      />

      <meta
        key="twitter:title"
        name="twitter:title"
        content={PlasmicTalks.pageMetadata.title}
      />
    </>
  );
}

function PlasmicTalks__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__o8Ejt)}>
            <p.PlasmicLink
              data-plasmic-name={"back"}
              data-plasmic-override={overrides.back}
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.back
              )}
              component={Link}
              href={`/`}
              platform={"gatsby"}
            >
              {"\u25c4 Back Home"}
            </p.PlasmicLink>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__bD0Ie)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__rcgr)}>
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {"Talks"}
                </h1>
                <p
                  data-plasmic-name={"p"}
                  data-plasmic-override={overrides.p}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.p
                  )}
                >
                  {"by Isaac Palka"}
                </p>
              </div>
              <AllTalks
                data-plasmic-name={"allTalks"}
                data-plasmic-override={overrides.allTalks}
                className={classNames("__wab_instance", sty.allTalks)}
              >
                <TalkPreview
                  data-plasmic-name={"nlpsummit"}
                  data-plasmic-override={overrides.nlpsummit}
                  className={classNames("__wab_instance", sty.nlpsummit)}
                  date={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__rjl
                      )}
                    >
                      {"Oct 6, 2022"}
                    </div>
                  }
                  destination={
                    "https://www.nlpsummit.org/from-unstructured-documents-to-a-longitudinal-health-record/"
                  }
                  summary={
                    "At the NLP Summit, my colleague and I cover how Invitae uses NLP to transform unstructured medical documents into structured data, using FHIR, to produce high-grade, large-volume patient records that are searchable and interoperable."
                  }
                  thumbnail={
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__sMw5B)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"100%"}
                      loading={"lazy"}
                      src={{
                        src: talkNlpsummitWYpPosvnr,
                        fullWidth: 800,
                        fullHeight: 446,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  title={
                    "From Unstructured Documents to a Longitudinal Health Record"
                  }
                />

                <TalkPreview
                  data-plasmic-name={"sealights"}
                  data-plasmic-override={overrides.sealights}
                  className={classNames("__wab_instance", sty.sealights)}
                  date={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___6SdgW
                      )}
                    >
                      {"Aug 10, 2022"}
                    </div>
                  }
                  destination={
                    "https://www.sealights.io/webinars/healthy-business-coverage-the-healthcare-software-executive-guide-to-achieving-quality-at-speed-funnel-form/#wpcf7-f23401-p23398-o1"
                  }
                  summary={
                    "In this webinar with the CEO of SeaLights, I introduce the concept of \u201cbusiness coverage\u201d to address some flaws in traditionally accepted QA methods. I cover some real world examples, with a shameless plug about Validaus."
                  }
                  thumbnail={
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__eW72T)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"100%"}
                      loading={"lazy"}
                      src={{
                        src: talkSealightsCJ3Kr0Ru,
                        fullWidth: 600,
                        fullHeight: 314,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  title={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zbAfr
                      )}
                    >
                      {'From "Code Coverage" to "Business Coverage"'}
                    </div>
                  }
                />

                <TalkPreview
                  data-plasmic-name={"worldfestival"}
                  data-plasmic-override={overrides.worldfestival}
                  className={classNames("__wab_instance", sty.worldfestival)}
                  date={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___6PAiv
                      )}
                    >
                      {"Aug 3, 2022"}
                    </div>
                  }
                  destination={"https://worldfestival.com/speakers/"}
                  summary={
                    "At the virtual conference WorldFestival, I cover what I view as the hidden and major costs behind managing an engineering team, and how choosing the right technology stack can in fact help your team scale."
                  }
                  thumbnail={
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__oQWy9)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"100%"}
                      loading={"lazy"}
                      src={{
                        src: talkWorldfestival1XYq3YTn9,
                        fullWidth: 800,
                        fullHeight: 418,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  title={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__x1779
                      )}
                    >
                      {"Scaling Your Team With Code"}
                    </div>
                  }
                />
              </AllTalks>
            </p.Stack>
          </div>
          <Copyright
            data-plasmic-name={"copyright"}
            data-plasmic-override={overrides.copyright}
            className={classNames("__wab_instance", sty.copyright)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "back",
    "h1",
    "p",
    "allTalks",
    "nlpsummit",
    "sealights",
    "worldfestival",
    "copyright"
  ],

  back: ["back"],
  h1: ["h1"],
  p: ["p"],
  allTalks: ["allTalks", "nlpsummit", "sealights", "worldfestival"],
  nlpsummit: ["nlpsummit"],
  sealights: ["sealights"],
  worldfestival: ["worldfestival"],
  copyright: ["copyright"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTalks__ArgProps,
          internalVariantPropNames: PlasmicTalks__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTalks__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTalks";
  } else {
    func.displayName = `PlasmicTalks.${nodeName}`;
  }
  return func;
}

export const PlasmicTalks = Object.assign(
  // Top-level PlasmicTalks renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    back: makeNodeComponent("back"),
    h1: makeNodeComponent("h1"),
    p: makeNodeComponent("p"),
    allTalks: makeNodeComponent("allTalks"),
    nlpsummit: makeNodeComponent("nlpsummit"),
    sealights: makeNodeComponent("sealights"),
    worldfestival: makeNodeComponent("worldfestival"),
    copyright: makeNodeComponent("copyright"),
    // Metadata about props expected for PlasmicTalks
    internalVariantProps: PlasmicTalks__VariantProps,
    internalArgProps: PlasmicTalks__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Talks",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicTalks;
/* prettier-ignore-end */
